import { Button as DevButton } from 'devextreme-react/button';
import DataGrid, {
    Column, FilterPanel, FilterRow,
    HeaderFilter, Selection, Sorting
} from 'devextreme-react/data-grid';
import { useCallback, useEffect, useMemo, useState } from "react";
import { hinhThucMienGiamApi } from "../../../api/hinhThucMienGiamApi";
import { thuPhiApi } from "../../../api/thuPhiApi";
import { showNotify } from "../../../helpers/toast";
import { sf_hinhthucmiengiam } from "../../../models/response/category/sf_hinhthucmiengiam";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { sf_mucphaithu_miengiam } from "../../../models/response/thu-phi/sf_mucphaithu_miengiam";
import { Button } from "../../buttons";
import { DefaultPopup } from "../../modal";
export type ThuPhiDieuChinhChietKhauBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    onChanged: () => void,
    ts_hocsinh: any
}
const ThuPhiDieuChinhChietKhauBtn = (props: ThuPhiDieuChinhChietKhauBtnProps) => {
    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    return (
        <>
            <DevButton
                text="Điều chỉnh chiết khấu"
                type="default"
                stylingMode="text"
                icon="plus"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowModal(true);
                }}
            />
            {isShowModal && <ThuPhiAddMienGiamModal
                onClose={() => { setIsShowModal(false) }}
                sf_mucphaithu={props.sf_mucphaithu}
                onChanged={() => {
                    setIsShowModal(false);
                    props.onChanged();
                }}
                ts_hocsinh={props.ts_hocsinh}
            />}
        </>
    )
}
type ThuPhiAddMienGiamModalProps = {
    sf_mucphaithu: sf_mucphaithu,
    onClose: () => void,
    onChanged: () => void
    ts_hocsinh: any
}

const ThuPhiAddMienGiamModal = (props: ThuPhiAddMienGiamModalProps) => {
    const [sf_hinhthucmiengiams, set_sf_hinhthucmiengiams] = useState<sf_hinhthucmiengiam[]>([])
    const [sf_hinhthucmiengiam_selected_ids, set_sf_hinhthucmiengiam_selected_ids] = useState<number[]>([])
    const [sf_mucphaithu_miengiams, st_sf_mucphaithu_miengiams] = useState<sf_mucphaithu_miengiam[]>([])
    const [isSaving, SetIsSaving] = useState<boolean>(false)
    useEffect(() => {
        handleReloadMucPhaiThuMienGiams()
    }, [props.sf_mucphaithu.id])
    useEffect(() => {
        handleReloadHinhThucMienGiams()
    }, [])

    const handleReloadHinhThucMienGiams = async () => {
        const res = await hinhThucMienGiamApi.select(props.sf_mucphaithu.nam_hoc)
        if (res.is_success) {
            set_sf_hinhthucmiengiams(res.data.filter((c: any) => c.dm_coso_id === props.ts_hocsinh.dm_coso_id))
        }
    }

    const handleReloadMucPhaiThuMienGiams = async () => {
        const res = await thuPhiApi.select_miengiam(props.sf_mucphaithu.id)
        if (res.is_success && res.data) {
            st_sf_mucphaithu_miengiams(res.data)
            set_sf_hinhthucmiengiam_selected_ids(res.data.map((x: sf_mucphaithu_miengiam) => x.sf_hinhthucmiengiam_id))
        }
    }
    const onSelectionChanged = ({ selectedRowKeys }: any) => {
        for (let i = selectedRowKeys.length - 1; i >= 0; i--) {
            const sf_hinhthucmiengiam_id = selectedRowKeys[i];

            if (sf_hinhthucmiengiam_id > 0) {
                const sf_hinhthucmiengiam = sf_hinhthucmiengiams.filter(x => x.id === sf_hinhthucmiengiam_id)[0];
                const nhom_mien_giam = sf_hinhthucmiengiam.nhom_mien_giam;
                const sf_hinhthucmiengiam_cung_nhoms = sf_hinhthucmiengiams.filter(x => x.nhom_mien_giam === nhom_mien_giam && x.id !== sf_hinhthucmiengiam_id);
                for (let j = 0; j < sf_hinhthucmiengiam_cung_nhoms.length; j++) {
                    const sf_hinhthucmiengiam_cung_nhom_id = sf_hinhthucmiengiam_cung_nhoms[j].id;
                    for (let k = 0; k <= i; k++) {
                        if (selectedRowKeys[k] === sf_hinhthucmiengiam_cung_nhom_id) {
                            selectedRowKeys[k] = -1;
                        }
                    }
                }
            }
        }

        const selectd_ids = selectedRowKeys.filter((x: number) => x > 0);
        set_sf_hinhthucmiengiam_selected_ids(selectd_ids);
    }
    const dataSource = useMemo(() => {
        return sf_hinhthucmiengiams.map(x => {
            const count = sf_mucphaithu_miengiams.filter(y => y.sf_hinhthucmiengiam_id == x.id).length;
            return { ...x, is_selected: count > 0 };
        });
    }, [sf_hinhthucmiengiams, sf_mucphaithu_miengiams])

    const handleSubmit = async () => {
        SetIsSaving(true)
        const data = sf_hinhthucmiengiams.map(x => {
            return {
                ...x,
                so_chung_tu: props.sf_mucphaithu.so_chung_tu,
                sf_mucphaithu_id: props.sf_mucphaithu.id,
                ma_hinhthucmiengiam: x.ma_hinh_thuc,
                is_selected: sf_hinhthucmiengiam_selected_ids.includes(x.id)
            };
        });
        const res = await thuPhiApi.save_miengiams(data);
        if (res.is_success) {
            props.onChanged()
            showNotify({ message: "Cập nhật thành công", type: "success" });
        } else {
            showNotify({ message: res.message || "Cập nhật thất bại", type: "error" });
        }
        SetIsSaving(false)
    }
    const onClose = useCallback(() => {
        window.animationHidePopup("")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [])
    return (
        <div>
            <DefaultPopup title="Điều chỉnh chiết khấu" maxWidth={900} width='80%' onClose={onClose}>
                <div className="pop-up-form">
                    <DataGrid
                        keyExpr={"id"}
                        dataSource={dataSource}
                        columnHidingEnabled={false}
                        columnAutoWidth={true}
                        showBorders={true}
                        showColumnLines={false}
                        showRowLines={false}
                        rowAlternationEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode={"nextColumn"}
                        hoverStateEnabled={true}
                        focusedRowEnabled={false}
                        height={window.innerHeight - 350}
                        noDataText="Không có dữ liệu"
                        selectedRowKeys={sf_hinhthucmiengiam_selected_ids}
                        onSelectionChanged={onSelectionChanged}
                        paging={{ enabled: false }}
                        wordWrapEnabled={true}
                        loadPanel={{ enabled: false }}
                    >
                        <Sorting mode="multiple" />
                        <Selection mode="multiple" allowSelectAll={false} showCheckBoxesMode="always"></Selection>
                        <FilterRow visible={true} />
                        <FilterPanel visible={false} />
                        <HeaderFilter visible={true} />
                        <Column dataField="ma_hinh_thuc" caption="Mã hình thức" width={250}></Column>
                        <Column dataField="hinh_thuc_mien_giam" caption="Hình thức miễn giảm" minWidth={250}></Column>
                        <Column dataField="nhom_mien_giam" caption="Nhóm miễn giảm" groupIndex={0}></Column>
                    </DataGrid>
                </div>
                <div className="pop-up-actions">
                    <Button text="Đóng" icon="fa fa-times" onClick={() => { props.onClose() }} />{' '}
                    <Button text="Áp dụng" type="normal" icon="fas fa-check-square" onClick={handleSubmit} isLoading={isSaving} />
                </div>
            </DefaultPopup>
        </div>
    );
}
export default ThuPhiDieuChinhChietKhauBtn
